export default "__VITE_ASSET__CpL0oT8l__"